import { render, staticRenderFns } from "./PartnerAgreement.vue?vue&type=template&id=7d05b50a&scoped=true&"
import script from "./PartnerAgreement.vue?vue&type=script&lang=js&"
export * from "./PartnerAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d05b50a",
  null
  
)

export default component.exports